import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { BranchService } from '../../service/ObjectModelServices/BranchService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import CloneBranchPopup from '../Popups/CloneBranchPopup';
import CookieHandler from '../../pages/LandingPage/Authentication/CookieHandler'

const BranchListTable = () => {

    const storeId = CookieHandler.getCookie("storeId");

    let emptyBranch = {
        id: null,
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        nativeLanguage: ''
    };

    const [branches, setBranches] = useState([]);
    const [branchDialog, setBranchDialog] = useState(false);
    const [cloneBranchDialog, setCloneBranchDialog] = useState(false);
    const [deleteBranchDialog, setDeleteBranchDialog] = useState(false);
    const [deleteBranchesDialog, setDeleteBranchesDialog] = useState(false);
    const [branch, setBranch] = useState(emptyBranch);
    const [selectedBranches, setSelectedBranches] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    useEffect(() => {
        BranchService.getBranches().then(data => setBranches(data));
    }, []);

    const openNew = () => {
        setBranch(emptyBranch);
        setSubmitted(false);
        setBranchDialog(true);
    };

    const openClonebranchDailogue = () => {
        setSubmitted(false);
        setCloneBranchDialog(true);
    };


    const hideDialog = () => {
        setSubmitted(false);
        setBranchDialog(false);
    };

    const hideCloneBranchDialog = () => {
        setSubmitted(false);
        setCloneBranchDialog(false);
    };

    const hideDeleteBranchDialog = () => {
        setDeleteBranchDialog(false);
    };

    const hideDeleteBranchesDialog = () => {
        setDeleteBranchesDialog(false);
    };

    const saveBranch = () => {
        setSubmitted(true);

        if (branch.name.trim()) {
            let _branches = [...branches];
            let _branch = { ...branch };

            if (branch.id) {
                const index = findIndexById(branch.id);

                _branches[index] = _branch;
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Branch Updated', life: 3000 });
            } else {
                _branch.id = createId();
                _branches.push(_branch);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Branch Created', life: 3000 });
            }

            setBranches(_branches);
            setBranchDialog(false);
            setBranch(emptyBranch);
        }
    };

    const editBranch = branch => {
        setBranch({ ...branch });
        setBranchDialog(true);
    };

    const confirmDeleteBranch = branch => {
        setBranch(branch);
        setDeleteBranchDialog(true);
    };

    const deleteBranch = () => {
        BranchService.deleteBranch(storeId, branch.id);
        let _branches = branches.filter(val => val.id !== branch.id);

        setBranches(_branches);
        setDeleteBranchDialog(false);
        setBranch(emptyBranch);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Branch Deleted', life: 3000 });
    };

    const findIndexById = id => {
        let index = -1;
        for (let i = 0; i < branches.length; i++) {
            if (branches[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    };

    const createId = () => {
        return Math.random().toString(36).substr(2, 9);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const confirmDeleteSelected = () => {
        setDeleteBranchesDialog(true);
    };

    const deleteSelectedBranches = () => {

        const promises = selectedBranches.map(branch => {
            return BranchService.deleteBranch(storeId, branch.id);
        });
    
        Promise.all(promises)
            .then(() => {
                let _branches = branches.filter(val => !selectedBranches.includes(val));
                setBranches(_branches);
                setDeleteBranchesDialog(false);
                setSelectedBranches(null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Branches Deleted', life: 3000 });
            })
            .catch(error => {
                console.error('Error deleting branches:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Some branches could not be deleted', life: 3000 });
            });
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _branch = { ...branch };
        _branch[`${name}`] = val;

        setBranch(_branch);
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Clone a Branch" icon="pi pi-copy" severity="success" onClick={openClonebranchDailogue} />
                <Button label="Delete Branch" icon="pi pi-trash" severity="danger" onClick={confirmDeleteSelected} disabled={!selectedBranches || !selectedBranches.length} />
            </div>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="New Branch" icon="pi pi-plus" severity="primary" onClick={openNew} />
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />;
            </div>
        )
        };

    const addressBodyTemplate = rowData => {
        return (
            <div>
                <div>{rowData.address.addressLine1}</div>
                <div>{rowData.address.addressLine2}</div>
                <div>{rowData.address.addressLine3}</div>
            </div>
        );
    };

    const cityBodyTemplate = rowData => {
        return rowData.address.city;
    };

    const nativeLanguageBodyTemplate = rowData => {
        return rowData.nativeLanguage;
    };

    const branchIdBodyTemplate = rowData => {
        return "#" + rowData.id;
    };

    const actionBodyTemplate = rowData => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => editBranch(rowData)} />
                <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeleteBranch(rowData)} />
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <h4 className="m-0">Manage Branches</h4>
            <div className="p-input-icon-left">
                <i className="pi pi-search"  style={{marginLeft:"10px"}} />
                <InputText style={{paddingLeft:"30px"}} type="search" onInput={e => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </div>
        </div>
    );

    const branchDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" onClick={saveBranch} />
        </React.Fragment>
    );

    const deleteBranchDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteBranchDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={deleteBranch} />
        </React.Fragment>
    );

    const deleteBranchesDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteBranchesDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={deleteSelectedBranches} />
        </React.Fragment>
    );

    return (
        <div>
            <Toast ref={toast} />
            <div className="card">
                <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                <DataTable ref={dt} value={branches} selection={selectedBranches} onSelectionChange={e => setSelectedBranches(e.value)}
                    dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} branches" globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                    <Column selectionMode="multiple" exportable={false}></Column>
                    <Column field="id" header="Id" body={branchIdBodyTemplate} sortable style={{ minWidth: '12rem' }}></Column>
                    <Column header="Branch Address" body={addressBodyTemplate} sortable></Column>
                    <Column field="city" header="City" body={cityBodyTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="nativeLanguage" header="Language" body={nativeLanguageBodyTemplate} sortable style={{ minWidth: '10rem' }}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '12rem' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={branchDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Branch Details" modal className="p-fluid" footer={branchDialogFooter} onHide={hideDialog}>
                <div className="field">
                    <label htmlFor="name" className="font-bold">Branch Name</label>
                    <InputText id="name" value={branch.name} onChange={e => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !branch.name })} />
                    {submitted && !branch.name && <small className="p-error">Name is required.</small>}
                </div>
                <div className="field">
                    <label htmlFor="description" className="font-bold">Description</label>
                    <InputTextarea id="description" value={branch.description} onChange={e => onInputChange(e, 'description')} required rows={3} cols={20} />
                </div>
                <div className="field">
                    <label htmlFor="addressLine1" className="font-bold">Address Line 1</label>
                    <InputText id="addressLine1" value={branch.addressLine1} onChange={e => onInputChange(e, 'addressLine1')} required />
                </div>
                <div className="field">
                    <label htmlFor="addressLine2" className="font-bold">Address Line 2</label>
                    <InputText id="addressLine2" value={branch.addressLine2} onChange={e => onInputChange(e, 'addressLine2')} />
                </div>
                <div className="field">
                    <label htmlFor="addressLine3" className="font-bold">Address Line 3</label>
                    <InputText id="addressLine3" value={branch.addressLine3} onChange={e => onInputChange(e, 'addressLine3')} />
                </div>
                <div className="field">
                    <label htmlFor="city" className="font-bold">City</label>
                    <InputText id="city" value={branch.city} onChange={e => onInputChange(e, 'city')} required />
                </div>
                <div className="field">
                    <label htmlFor="nativeLanguage" className="font-bold">Language</label>
                    <InputText id="nativeLanguage" value={branch.nativeLanguage} onChange={e => onInputChange(e, 'nativeLanguage')} required />
                </div>
            </Dialog>



            <Dialog visible={cloneBranchDialog} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Clone a Branch" modal className="p-fluid" onHide={hideCloneBranchDialog}>
                <CloneBranchPopup/>
            </Dialog>





            <Dialog visible={deleteBranchDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteBranchDialogFooter} onHide={hideDeleteBranchDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {branch && <span>Are you sure you want to delete <b>{branch.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={deleteBranchesDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteBranchesDialogFooter} onHide={hideDeleteBranchesDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {branch && <span>Are you sure you want to delete the selected branches?</span>}
                </div>
            </Dialog>
        </div>
    );
};

export default BranchListTable;
